import React, { useState } from 'react'

import Box from '@mui/material/Box';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Card from '@mui/material/Card';

import PlusIcon from '../../../images/NavBarImages/Plus_48px.png';
import { Autocomplete, TextField, InputAdornment, Button } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import MinusIcon from '@mui/icons-material/Remove';
import PromoCodeIcon from '../../../images/HomeImages/PromoCode.png';
import Popper from '@mui/material/Popper';
import AddressPanel from './AddressPanel';

const CartForm = ({ cart, LanguageID, ItemCount, setItemCount, Dcrement, Increment, CartTotalPrcice, CartTotalDiscount, DeliveryTransPrice, setDeliveryTransPrice, ThemeColor, PromoCodeStatus, ListOfPromoCode, getBranchPromoCode, PromoCode, PromoCodeStatusChick, handleTryAgain, DBTransListPrice, setCostAddress, CostAddress, ShowAddressBar, setShowAddressBar, ShowAddress, SubsecriptionType
  , ServiceStatus
  , ServicPrice }) => {



  const normalizedPromo = PromoCode.normalize('NFC').replace(/\s/g, '').trim();

  const [inputValue, setInputValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);
  const topFiveOptions = DBTransListPrice
    .filter(option =>
      option.addressName?.toLowerCase().includes(inputValue.toLowerCase())
    )
    .slice(0, 4);

  const handleSelect = (event, newValue) => {
    setSelectedValue(newValue);

    if (newValue) {
      setDeliveryTransPrice(newValue.transPrice)
      setCostAddress(newValue.addressName)

    }
  };





  const CustomPopper = (props) => (
    <Popper
      {...props}
      placement="top-start"
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 8], // optional: space between input and dropdown
          },
        },
      ]}
    />
  );






  return (

    <div >

      {ShowAddressBar == 0 && (
        <div className='row' style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          height: '52vh',           // Set height to allow space
          overflowY: 'auto', translate: 'no'
        }}>
          {cart.map((item) => (
            <div>
              <Card sx={{
                minWidth: 350, maxWidth: 350, marginTop: '20px', marginBottom: '5px', translate: 'no'




              }} >



                <div className='row' style={{ display: 'flex', translate: 'no' }}>




                  <div className='col' style={{ minWidth: '70%', translate: 'no' }}>
                    <div className='row' style={{ fontSize: '16px', textAlign: 'end', fontWeight: 'bold', marginTop: '12px', fontFamily: 'basheer', translate: 'no' }}>

                      <label>{item.itemName}{' '}{item.itemNote}</label>


                    </div>
                    <div className='row' style={{ fontSize: '12px', textAlign: 'end', display: 'flex', direction: 'rtl', marginTop: '5px', translate: 'no' }}>

                      <label className='col' style={{ justifyContent: 'center', fontSize: '16px', fontFamily: 'basheer', color: `#${ThemeColor}`, translate: 'no' }}>
                        {item.totalPrice.toLocaleString()}
                      </label>
                      <label className='col' style={{ justifyContent: 'center', fontSize: '16px', marginRight: '5px', fontFamily: 'basheer', color: `#${ThemeColor}`, translate: 'no' }}>
                        د.ع
                      </label>



                    </div>
                    <div className='row' style={{ fontSize: '12px', textAlign: 'start', translate: 'no' }}>

                      <button
                        style={{
                          border: 'none',
                          background: 'none',
                          fontFamily: 'basheer', translate: 'no'
                        }}
                        onClick={() => Dcrement(item)}
                      >
                        {item.quantity === 1 ? (
                          <DeleteIcon style={{ color: `#${ThemeColor}` }} />
                        ) : (
                          <MinusIcon style={{ color: `#${ThemeColor}` }} />
                        )}
                      </button>

                      <label
                        style={{
                          color: 'black',
                          fontSize: '24pt',
                          fontFamily: 'basheer',
                          margin: '20px', translate: 'no'
                        }}
                      >
                        {item.quantity}
                      </label>

                      <button
                        style={{
                          border: 'none',
                          background: 'none',
                          color: 'black', translate: 'no'
                        }}
                        onClick={() => Increment(item)}
                      >
                        <AddIcon style={{ color: `#20A17F` }} />
                      </button>


                    </div>








                  </div>

                  <div className='col'   >

                    <img src={item.imageUrl} alt="Logo" style={{ textAlign: 'end', borderRadius: '10px', maxHeight: 90, minHeight: 90, maxWidth: 90, minWidth: 90, margin: '8px', translate: 'no' }} />



                  </div>

                </div>





              </Card>



            </div>

          ))}

        </div>
      )}


      {PromoCodeStatus == 1 && (
        <div className='row' style={{ marginRight: '30px', marginLeft: '50px', direction: 'rtl', translate: 'no' }} >
          <TextField
            style={{
              backgroundColor: '#F7F7F7', minWidth: '100%', fontSize: '16px', fontFamily: 'basheer', border:
                PromoCodeStatusChick === 0
                  ? '0.5px solid #50575D'
                  : PromoCodeStatusChick === 1
                    ? '0.5px solid #28CA9E'
                    : '0.5px solid #D62828', borderRadius: '8px', translate: 'no'
            }}
            placeholder='اكتب البرموكود هنا...'
            value={PromoCode}
            onChange={(e) => getBranchPromoCode(e.target.value)}
            inputProps={{
              style: {
                color: PromoCodeStatusChick === 0
                  ? '#50575D'
                  : PromoCodeStatusChick === 1
                    ? '#28CA9E'
                    : '#D62828', borderRadius: '8px',
                fontSize: '14px',
                textAlign: 'right',
                fontFamily: 'basheer', translate: 'no'


              },
              readOnly: PromoCodeStatusChick !== 0, // Make read-only when not 0
            }}

            // Add InputProps to include an adornment
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {PromoCodeStatusChick === 2 ? (
                    <Button
                      style={{

                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontFamily: 'basheer',
                        fontSize: '13px',
                        borderRight: '3px solid #D62828', // <- This adds a bold right border
                        borderRadius: 0, // optional: removes default rounded corners
                        paddingRight: '8px', translate: 'no'// optional: spacing from border to text
                      }}
                      onClick={handleTryAgain}
                      sx={{
                        color: '#353B41',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        fontFamily: 'basheer',
                        fontSize: '13px', translate: 'no'
                      }}
                    >

                      إعادة المحاولة
                    </Button>
                  ) : (
                    <img src={PromoCodeIcon} alt="Icon" />
                  )}
                </InputAdornment>
              )
            }}
          />
        </div>
      )}


      {SubsecriptionType == 'ECart' && (
        <div className='row' style={{ marginRight: '30px', marginLeft: '50px', direction: 'rtl', marginTop: '5px', translate: 'no' }} >
          <TextField
            style={{
              backgroundColor: '#F7F7F7', minWidth: '100%', fontSize: '16px', fontFamily: 'basheer', border:
                PromoCodeStatusChick === 0
                  ? '0.5px solid #50575D'
                  : PromoCodeStatusChick === 1
                    ? '0.5px solid #28CA9E'
                    : '0.5px solid #D62828', borderRadius: '8px', translate: 'no'

            }}
            placeholder="ابحث عن العنوان او المنطقة هنا..."
            value={CostAddress}

            onFocus={() => {
              if (ShowAddress !== 1) {
                setShowAddressBar(true);
              }
            }}



            inputProps={{
              style: {
                color: PromoCodeStatusChick === 0
                  ? '#50575D'
                  : PromoCodeStatusChick === 1
                    ? '#28CA9E'
                    : '#D62828', borderRadius: '8px',
                fontSize: '14px',
                textAlign: 'right',
                fontFamily: 'basheer',
                padding: '8px 10px', // Reduces vertical padding
                height: '21px', // Adjust line height
                translate: 'no'
              },
              readOnly: PromoCodeStatusChick !== 0, // Make read-only when not 0
            }}
          // Add InputProps to include an adornment

          />
        </div>
      )}

      {/**   
      {PromoCodeStatusChick != 1 && (
           



        <div className='row' style={{ marginRight: '30px', marginTop: '5px', marginLeft: '50px', direction: 'rtl' }} >
          <Autocomplete
            options={topFiveOptions}
            getOptionLabel={(option) => option.addressName || ''}
            inputValue={inputValue}
            
            onInputChange={(e, newInput) => setInputValue(newInput)}
            onChange={handleSelect}
           PopperComponent={CustomPopper}
            renderOption={(props, option) => (
              <li
                {...props}
                style={{
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingInline: '4px',
                  fontFamily: 'basheer',
                  fontSize: '14px',
                  backgroundColor: '#F7F7F7',
                   margin: 0,
                    
                }}
              >
                {option.addressName}
              </li>
            )}

            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="ابحث عن العنوان او المنطقة هنا..."
                variant="outlined"
               
                sx={{
                  backgroundColor: '#F7F7F7',
                  minWidth: '100%',
                  fontSize: '16px',
                  fontFamily: 'basheer',
                  direction: 'rtl',
                  '& .MuiOutlinedInput-root': {
                    padding: '2px 8px',
                    minHeight: '36px', // Adjust this value as needed
                  },
                  '& input': {
                    textAlign: 'right',
                    fontSize: '14px',
                    fontFamily: 'basheer',
                    backgroundColor: '#F7F7F7',
                  }
                }}
              />
            )}
          />
        </div>






      )}

*/}





      <div style={{ display: 'flex', direction: 'rtl', justifyContent: 'space-between', marginTop: '10px', translate: 'no' }} className='row'>
        <div className='col' style={{ marginRight: '30px', marginLeftL: '20px', translate: 'no' }}>
          <label style={{ fontSize: '16px', fontFamily: 'basheer', color: '#A4B0B6', translate: 'no' }}>تكلفة الطلب </label>
        </div>



        <div className='col' style={{ marginLeft: '30px', translate: 'no' }}>
          <label style={{ fontSize: '16px', fontFamily: 'basheer', color: '#A4B0B6', marginLeft: '20px', translate: 'no' }}>   {CartTotalPrcice.toLocaleString()} د.ع</label>
        </div>
      </div>


      <div style={{ display: 'flex', direction: 'rtl', justifyContent: 'space-between', translate: 'no' }} className='row'>
        <div className='col' style={{ marginRight: '30px', marginLeftL: '20px', translate: 'no' }}>
          <label style={{ fontSize: '16px', fontFamily: 'basheer', color: '#A4B0B6', translate: 'no' }}>الخصم </label>
        </div>

        <div className='col' style={{ marginLeft: '30px' }}>
          <label style={{ fontSize: '16px', fontFamily: 'basheer', color: '#A4B0B6', marginLeft: '20px', translate: 'no' }}>   {CartTotalDiscount.toLocaleString()} د.ع</label>
        </div>

      </div>


      <div style={{ display: 'flex', direction: 'rtl', justifyContent: 'space-between', translate: 'no' }} className='row'>
        <div className='col' style={{ marginRight: '30px', marginLeftL: '20px', translate: 'no' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'basheer', color: '#A4B0B6', translate: 'no' }}>التوصيل</label>
        </div>

        <div className='col' style={{ marginLeft: '30px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'basheer', color: '#A4B0B6', marginLeft: '20px', translate: 'no' }}>   {DeliveryTransPrice} د.ع</label>
        </div>

      </div>


      {(ServiceStatus == true) && (
        <div style={{ display: 'flex', direction: 'rtl', justifyContent: 'space-between', translate: 'no' }} className='row'>
          <div className='col' style={{ marginRight: '30px', marginLeftL: '20px', translate: 'no' }}>
            <label style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'basheer', color: '#A4B0B6', translate: 'no' }}>الخدمة</label>
          </div>

          <div className='col' style={{ marginLeft: '30px' }}>
            <label style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'basheer', color: '#A4B0B6', marginLeft: '20px', translate: 'no' }}>   {ServicPrice} د.ع</label>
          </div>

        </div>
      )}


      {/* This is a comment inside JSX 
      <div className='row'>

        <label style={{ fontSize: '16px', color: 'gray' }}>   --------------------------------------------------</label>

      </div>


      <div style={{ display: 'flex', direction: 'rtl', justifyContent: 'space-between' }} className='row'>
        <div className='col' style={{ marginRight: '30px', marginLeftL: '20px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'basheer' }}>المجموع</label>
        </div>

        <div className='col' style={{ marginLeft: '30px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'basheer', marginLeft: '20px' }}>   {CartTotalPrcice - CartTotalDiscount + DeliveryTransPrice} د.ع</label>
        </div>

      </div>
*/}

      <AddressPanel
        open={ShowAddressBar}
        onClose={() => setShowAddressBar(false)}
        addresses={DBTransListPrice}
        ThemeColor={ThemeColor}
        setCostAddress={setCostAddress}
        setDeliveryTransPrice={setDeliveryTransPrice}
        PromoCodeStatus={PromoCodeStatus}
      />


    </div>




  )
}


export default CartForm